import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBw3m-bLR2ko7uEHfFW9BMCDaCWu1A1iMo",
  authDomain: "bio-edge.firebaseapp.com",
  projectId: "bio-edge",
  storageBucket: "bio-edge.firebasestorage.app",
  messagingSenderId: "746188934599",
  appId: "1:746188934599:web:1be820a622795c62741de2"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { firebaseApp, auth, db, storage };
